import { boot } from './ui.js';

const params = new URLSearchParams(location.search);
const editSlug = params.get('edit') || null;

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

boot({ editSlug });
